import React from "react";
import { Route, Redirect, Switch } from "react-router-dom";
import URLS from "../../config/navigation";

import ball from '../../assets/img/ball.svg';
import logo from '../../assets/img/logo.svg';

import {
  ActivateAccount,
  SignIn,
  SignUp,
  ResetPassword,
  ForgotPassword
} from "../../screens/Auth";
import {getToken} from "../../utils";
import { useRouteMatch } from "react-router-dom";
import PublicProfileUrl from "../PublicProfileUrl";
import { AuthRoute } from "../../utils/constant";

const Auth = () => {
  let match = useRouteMatch('/:profileUrl');
  let isProfilePage = (match && match.params && AuthRoute.find( item => item === match.params.profileUrl)?.length >= 1) || false;

  return (
      <>
        <div className={isProfilePage ? "authContainer" : ""}>
          <div className={isProfilePage ? "background" : ""} />
          {isProfilePage && <img className={"backgroundBall"} src={ball} alt=""/>}
          <div className={isProfilePage ? "contentWrapper" : ""}>
            <div className={isProfilePage ? "content" : ""}>
              <div className={isProfilePage ? "logo" : ""}>
                {isProfilePage && <img className={"logo-img"} src={logo} alt="Logo"/>}
              </div>
              <Switch>
                <Route path={URLS.AUTH.SIGNIN} component={SignIn} />
                <Route path={URLS.AUTH.SIGNUP} component={SignUp} />
                <Route path={URLS.AUTH.ACTIVATE_ACCOUNT} component={ActivateAccount} />
                <Route path={URLS.AUTH.RESET_PASSWORD} component={ResetPassword} />
                <Route path={URLS.AUTH.FORGOT_PASSWORD} component={ForgotPassword} />
                <Route
                    strict
                    exact
                    path="/:profileUrl"
                    component={PublicProfileUrl}
                />
                <Route component={() =>  getToken() ? <Redirect to={URLS.PROFILE.ROOT}/> : <Redirect to={URLS.AUTH.SIGNIN} />} />
              </Switch>
            </div>
          </div>
        </div>
        </>
  );
};

export default Auth;
